const ROLE_HOME = {
    super_admin: '/admin',
    platform_admin: '/admin',
    restaurant_admin: '/r',
    manager: '/r',
    waiter: '/r/waiter',
    kitchen: '/r/kitchen',
};

export function homeForRole(role) {
    return ROLE_HOME[role] || '/r';
}

export function canAccessPath(role, path, { restaurantId } = {}) {
    if (!path) return false;
    if (path === '/admin') return role === 'super_admin' || role === 'platform_admin';
    if (path.startsWith('/r')) {
        if (role === 'super_admin' || role === 'platform_admin') return Boolean(restaurantId);
        return ['restaurant_admin', 'manager', 'waiter', 'kitchen'].includes(role);
    }
    return false;
}

export function destinationForRole(role, fromPath, options = {}) {
    const fallback = homeForRole(role);
    if (!fromPath) return fallback;
    if (canAccessPath(role, fromPath, options)) return fromPath;
    return fallback;
}
